// DeviceSizeHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

export class DeviceSizeHandler extends React.PureComponent {
  handleUpdateSize = debounce(async () => {
    const { setDeviceSize } = this.props;
    const { calculatePopupNotificationSize } = this.props;
    await setDeviceSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    calculatePopupNotificationSize();
  }, 500); // TODO: remote config
  componentDidMount() {
    this.handleUpdateSize();
    window.addEventListener('resize', this.handleUpdateSize);
    window.addEventListener('orientationchange', this.handleUpdateSize);
    window.addEventListener('focusout', this.handleUpdateSize);
  }
  componentWillUnmount() {
    this.handleUpdateSize.cancel();
    window.removeEventListener('resize', this.handleUpdateSize);
    window.removeEventListener('orientationchange', this.handleUpdateSize);
    window.removeEventListener('focusout', this.handleUpdateSize);
  }
  render() {
    return null;
  }
}

DeviceSizeHandler.propTypes = {
  setDeviceSize: PropTypes.func,
  calculatePopupNotificationSize: PropTypes.func,
};

DeviceSizeHandler.defaultProps = {
  setDeviceSize: () => null,
  calculatePopupNotificationSize: () => null,
};

export default DeviceSizeHandler;
